import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/common/Header';
import DoctorBottomNav from '../../components/doctor/DoctorBottomNav';
import { InlineLoader } from '../../components/common/Loader';
import { getDoctorConversations } from '../../services/doctorService';
import { truncate } from '../../utils/helpers';

function StoreConvCard({ conv }) {
  const navigate = useNavigate();
  const last     = conv.lastMessage;
  const timeStr  = last?.createdAt
    ? new Date(last.createdAt).toLocaleTimeString('en',{hour:'2-digit',minute:'2-digit',hour12:true})
    : '';
  const preview = !last             ? 'No messages yet'
    : last.type === 'image'         ? '📷 Photo'
    : last.type === 'pdf'           ? '📄 Document'
    : last.type === 'voice'         ? '🎙 Voice note'
    : truncate(last.message || '', 45);

  return (
    <button onClick={() => navigate(`/doctor/medicine-chat/${conv._id}`)}
      className="w-full flex items-center gap-3 px-4 py-4 bg-white border-b border-border active:bg-green-50 text-left transition-colors">
      <div className="relative flex-shrink-0">
        <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
          <i className="fa-solid fa-user text-green-600 text-base" />
        </div>
        {conv.unreadCount > 0 && (
          <span className="absolute -top-0.5 -right-0.5 w-5 h-5 bg-green-600 text-white text-[9px] font-bold rounded-full flex items-center justify-center">
            {conv.unreadCount > 9 ? '9+' : conv.unreadCount}
          </span>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-0.5">
          <p className="text-sm font-bold text-text-primary">Patient Enquiry</p>
          <span className="text-[10px] text-text-muted">{timeStr}</span>
        </div>
        <p className={`text-xs truncate ${conv.unreadCount > 0 ? 'text-text-primary font-medium' : 'text-text-muted'}`}>
          {preview}
        </p>
      </div>
      <i className="fa-solid fa-chevron-right text-slate-300 text-xs flex-shrink-0" />
    </button>
  );
}

export default function DoctorMedicineStoreChatList() {
  const [storeConvs, setStoreConvs] = useState([]);
  const [loading, setLoading]       = useState(true);

  useEffect(() => {
    getDoctorConversations()
      .then(res => setStoreConvs(res.storeConversations || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page-container">
      <Header title="Medicine Store Chats" showBack />

      {/* Info banner */}
      <div className="bg-green-50 border-b border-green-200 px-4 py-3 flex items-center gap-3">
        <div className="w-9 h-9 bg-green-600 rounded-xl flex items-center justify-center flex-shrink-0">
          <i className="fa-solid fa-pills text-white text-sm" />
        </div>
        <div>
          <p className="text-xs font-bold text-green-800">Medicine Store Inbox</p>
          <p className="text-[10px] text-green-600">No time limit · Patients can message anytime · Voice & video call available</p>
        </div>
      </div>

      {loading ? <InlineLoader text="Loading medicine chats..." /> :
       storeConvs.length === 0 ? (
        <div className="flex flex-col items-center py-16 gap-3 text-center px-8">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <i className="fa-solid fa-pills text-green-400 text-2xl" />
          </div>
          <p className="font-semibold text-text-primary">No medicine store chats yet</p>
          <p className="text-sm text-text-muted">When patients contact your medicine store, they'll appear here</p>
        </div>
       ) : (
        <div className="pb-20">
          <div className="px-4 py-2 bg-green-50 border-b border-border">
            <span className="text-xs font-bold text-green-700 uppercase tracking-wider">
              {storeConvs.length} patient enquir{storeConvs.length === 1 ? 'y' : 'ies'}
            </span>
          </div>
          {storeConvs.map(c => <StoreConvCard key={c._id} conv={c} />)}
        </div>
       )}

      <DoctorBottomNav />
    </div>
  );
}
